"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiagnosticEventsToJSON = exports.DiagnosticEventsFromJSONTyped = exports.DiagnosticEventsFromJSON = exports.instanceOfDiagnosticEvents = void 0;
var runtime_1 = require("../runtime");
var DiagnosticEvent_1 = require("./DiagnosticEvent");
/**
 * Check if a given object implements the DiagnosticEvents interface.
 */
function instanceOfDiagnosticEvents(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfDiagnosticEvents = instanceOfDiagnosticEvents;
function DiagnosticEventsFromJSON(json) {
    return DiagnosticEventsFromJSONTyped(json, false);
}
exports.DiagnosticEventsFromJSON = DiagnosticEventsFromJSON;
function DiagnosticEventsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'total': !(0, runtime_1.exists)(json, 'total') ? undefined : json['total'],
        'timestamp': !(0, runtime_1.exists)(json, 'timestamp') ? undefined : json['timestamp'],
        'eventCounts': !(0, runtime_1.exists)(json, 'event_counts') ? undefined : (json['event_counts'].map(DiagnosticEvent_1.DiagnosticEventFromJSON)),
    };
}
exports.DiagnosticEventsFromJSONTyped = DiagnosticEventsFromJSONTyped;
function DiagnosticEventsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'total': value.total,
        'timestamp': value.timestamp,
        'event_counts': value.eventCounts === undefined ? undefined : (value.eventCounts.map(DiagnosticEvent_1.DiagnosticEventToJSON)),
    };
}
exports.DiagnosticEventsToJSON = DiagnosticEventsToJSON;
